import { IconButton, IconButtonProps } from "@mui/material"
import { useColorScheme } from "@mui/material/styles"
import React, { useRef } from "react"
import { noop } from "src/utils/utils"

import { DarkModeSwitch } from "./DarkModeSwitch"

export function ThemeMode(props: IconButtonProps) {
  const { mode, setMode, systemMode } = useColorScheme()

  const switchOn = useRef<HTMLAudioElement>(null)
  const switchOff = useRef<HTMLAudioElement>(null)

  const isDarkMode = mode === "dark" || systemMode === "dark"

  return (
    <>
      <IconButton
        onClick={() => {
          if (isDarkMode) {
            setMode("light")
            switchOn.current?.play()
          } else {
            setMode("dark")
            switchOff.current?.play()
          }
        }}
        {...props}
      >
        <DarkModeSwitch checked={isDarkMode} onChange={noop} />
      </IconButton>
      <audio ref={switchOn} src="/switch_sound_on.mp3">
        <track kind="captions" label="Light switch turning on" />
      </audio>
      <audio ref={switchOff} src="/switch_sound_off.mp3">
        <track kind="captions" label="Light switch turning off" />
      </audio>
    </>
  )
}
